import React from 'react';
import './toastMessage.css';
import { injectStyle } from 'react-toastify/dist/inject-style';
import { toast } from 'react-toastify';
import { ToastMsgMapping } from './toastMessageMapping';

if (typeof window !== 'undefined') {
  injectStyle();
}

export const toastMsg = (
  message,
  description,
  type = "dark",
  autoClose = ToastMsgMapping[type]?.msgTime !== undefined ? ToastMsgMapping[type]?.msgTime : 5000,
  closeButton = false,
  hideProgressBar = true,
  pauseOnHover = false
) => {
  const newReg = /^[A-Za-z][A-Za-z]+$/g;
  let newRes = newReg.test(message);
  if (ToastMsgMapping[type]) {
    toast(
      <div
        className="toastMsg"
        style={{
          justifyContent: newRes ? 'left' : 'center',
          backgroundColor: ToastMsgMapping[type]?.backgroundColour,

          color: ToastMsgMapping[type]?.textColour,
          borderColor: ToastMsgMapping[type]?.borderColour,
        }}
      >
        <div
          className="message-and-description"
          style={{ alignItems: newRes ? 'flex-start' : 'center' }}
        >
          {message ? <div className="message">{message}</div> : null}
          {ToastMsgMapping[type]?.isDescription && description ? (
            <div className="description" style={{ marginTop: '2px' }}>
              {description}
            </div>
          ) : null}
        </div>
      </div>,
      {
        position: 'top-center',
        closeButton,
        autoClose,
        hideProgressBar,
        pauseOnHover,
        toastId: 'firstId',
      }
    );
  } else {
    toast.dark(message, {
      position: 'top-center',
      closeButton,
      autoClose,
      hideProgressBar,
      pauseOnHover,
    });
  }
};

export const toastMsgConfig = (message, width, height) => {
  toast.dark(message, {
    style: { width: width, height: height },
    position: 'top-center',
    closeButton: false,
    autoClose: 2000,
    hideProgressBar: true,
    pauseOnHover: false,
  });
};
